import { useTranslation } from 'react-i18next';

import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/solid';
import { Link, useSubmit } from '@remix-run/react';
import cx from 'classnames';

import useMenu from '../_hooks/useMenu';

interface Props {
  subscriberId: string;
  hasPreferencesEnabled: boolean;
}

const Menu = ({ subscriberId, hasPreferencesEnabled }: Props) => {
  const submit = useSubmit();
  const { isManagePage, isBillingPage, isPreferencesPage } = useMenu();

  const { t } = useTranslation('', { keyPrefix: 'settings_side_nav.items' });

  const items = [
    {
      href: `/subscribe/${subscriberId}/manage`,
      text: t('general_information'),
      active: isManagePage,
    },
    {
      href: `/subscribe/${subscriberId}/billing`,
      text: t('billing'),
      active: isBillingPage,
    },
  ];

  if (hasPreferencesEnabled) {
    items.push({
      href: `/subscribe/${subscriberId}/preferences`,
      text: t('preferences'),
      active: isPreferencesPage,
    });
  }

  const handleLogout = () => {
    const formData = new FormData();
    formData.append('pathname', window?.location?.pathname);

    submit(formData, {
      method: 'post',
      action: '/logout',
    });
  };

  return (
    <ul className="space-y-4">
      {items.map((item) => (
        <li key={item.href}>
          <Link
            to={item.href}
            className={cx('text-gray-500 transition-colors hover:text-gray-700 active:text-gray-400', {
              'cursor-default font-medium text-gray-900 hover:text-gray-900 active:text-gray-900': item.active,
            })}
            aria-current={item.active ? 'page' : undefined}
          >
            {item.text}
          </Link>
        </li>
      ))}
      <button
        className="flex items-center gap-4 text-gray-500 transition-colors hover:text-gray-700 active:text-gray-400"
        onClick={handleLogout}
      >
        <span>{t('logout')}</span>
        <ArrowTopRightOnSquareIcon className="inline-block h-4 w-4" />
      </button>
    </ul>
  );
};

export default Menu;
